'use client'
import React, { useRef, useState } from "react";
import data from "./accordiondata";
import { RiArrowDropDownLine } from "react-icons/ri";
import "./connect.css";
import { FaPlus } from "react-icons/fa6";


//  accordionitem component
const AccordionItem = ({ question, answer, isOpen, onClick }) => {
  const contentHeight = useRef();
  return (
    
    <div className="wrapper">
      <button
        className={`question-container ${isOpen ? "active" : ""}`}
        onClick={onClick}
      >
        <FaPlus className={`arrow ${isOpen ? "active" : ""}`} />
        <p className="question-content">{question}</p>
        
      </button>

      <div
        ref={contentHeight}
        className="answer-container"
        style={
          isOpen
            ? { height: contentHeight.current.scrollHeight }
            : { height: "0px" }
        }
      >
         <p
          className="answer-content"
          dangerouslySetInnerHTML={{ __html: answer }}
        ></p>
      </div>
    </div>
  );
};

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleItemClick = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <section className="section-bg">
       <div className="faq-cont">
          <div className="cal-desk-cont">
            <div className="cal-desk">
                  <div style={{ position: 'relative', flex: "1" }}>
                      <img
                        className="premium-pill"
                        src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/Layer+1+copy+2.png"
                        alt=""
                      />
                      <span className="premium-pill-text">Go premium</span>
                      <img
                        className="white-shape"
                        src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/oddshp.png"
                      />
                      <div className="ex-inner-text-2">
                        <span style={{ color: "#d4232b" }}>
                          ARE YOU AN EXISTING
                          <br />
                          FLP MEMBER?{" "}
                        </span>{" "}
                        <br /> <span className="upgrade-today">UPGRADE TODAY</span>
                      </div>
                   </div>
                  <div style={{ flex: "1" }}>
                    <div className="red-bg" >
                      <h4>Upgrade to FLP Connect and skip the joining fees.</h4>
                      Enjoy the same brilliant FLP Standard benefits PLUS get R249
                      back in airtime every month.
                      <br /><br />
                      Upgrade from FLP Standard to FLP Connect for R249pm and you
                      will be FLP Connect-ed to living your best life!
                    </div>
                  </div>
              </div>
            <a href="/account">
                <button className="upgrade-but2">
                   UPGRADE <br /> NOW
                </button>
            </a>
          </div>
          <div
          style={{
                background: "transparent",
                justifyContent: "center",
              }}
              className="item2 alreadymember"
              id="memberal"
            >
            <div className="package-card-parent">
              <div className="package-card">
                <div className="ex-inner-text-2">
                  <span style={{ color: "#d4232b" }}>
                    ARE YOU AN EXISTING
                    <br />
                    FLP MEMBER?{" "}
                  </span>{" "}
                  <br /> <span className="upgrade-today">UPGRADE TODAY</span>
                </div>
                <div
                  style={{ background: "#d4232b" }}
                  className="package-card-child"
                >
                  <img
                    className="package-card-img"
                    src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/oddshp.png"
                  />
                  <div className="package-card-text" style={{ display: "flex" }}>
                    <div>
                      <img
                        className="premium-pill"
                        src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/Layer+1+copy+2.png"
                        alt=""
                      />
                      <span className="premium-pill-text">Go premium</span>
  
                      <br />
                    </div>
                    <div style={{ padding: "30px" }}>
                      <h4>Upgrade to FLP Connect and skip the joining fees.</h4>
                      Enjoy the same brilliant FLP Standard benefits PLUS get R249
                      back in airtime every month.
                      <br />
                      Upgrade from FLP Standard to FLP Connect for R249pm and you
                      will be FLP Connect-ed to living your best life!
                    </div>
  
                    <a href="/account">
                      <button className="upgrade-but2">
                        UPGRADE <br /> NOW
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h2>FLP CONNECT FAQ’s</h2>
         
         <div>
          <div >
      {data.map((item, index) => (
        <AccordionItem
          key={index}
          question={item.question}
          answer={item.answer}
          isOpen={activeIndex === index}
          onClick={() => handleItemClick(index)}
        />
        
      ))}
    </div>
    </div>
          </div>
          
   
    </section>
  );
};

export default Accordion;
